import React, { useState } from "react";

const features = [
  {
    title: "Guided Courses",
    desc: "For every skill level, from beginner to advanced",
    icon: "🌱",
    more: [
      "Threat-informed training approach",
      "Real-world examples",
      "Skills assessment exercises",
      "Discord-based guidance",
    ],
  },
  {
    title: "In-browser Pentesting VM",
    desc: "Tackle all lab exercises from your browser",
    icon: "💻",
    more: [
      "In-browser pentesting VM (Pwnbox)",
      "Practice everything you learn",
      "No infrastructure or tool requirements",
    ],
  },
  {
    title: "Highly Practical",
    desc: "Practice in a real-world environment",
    icon: "🖱️",
    more: [
      "Interactive exercises against real-world apps",
      "Hands-on infrastructure challenges",
      "Gain valuable real-world experience",
    ],
  },
  {
    title: "Get Certified",
    desc: "Stand out in the job market, skyrocket your resume",
    icon: "🏅",
    more: [
      "Industry-recognized certifications",
      "Realistic examinations mimicking engagements",
      "Commercial-grade report required to pass",
    ],
  },
  {
    title: "Unlimited & Online",
    desc: "On-demand access from everywhere",
    icon: "🌍",
    more: [
      "Smaller, easy-to-digest courses online",
      "Lifetime access to completed courses",
    ],
  },
  {
    title: "Job & Skill Paths",
    desc: "Achieve job proficiency or learn a new skill",
    icon: "🎯",
    more: [
      "Acquire job or skill proficiency",
      "Develop an outside-the-box thinking mentality",
    ],
  },
];

const Section = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleTitle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="bg-gradient-to-br from-red-800 via-blue-900 to-red-950 py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
        MAD Academy
        </h2>
        <p className="text-gray-200 max-w-2xl mx-auto mb-10">
          Prepare for your future in cybersecurity with interactive, guided
          training and industry certifications. Learn the skills needed to stand
          out from the competition.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center">
              {/* Card */}
              <div
                onClick={() => toggleTitle(index)}
                className={`w-full bg-gradient-to-b from-blue-950 to-red-900 border border-red-500 rounded-2xl p-6 text-center text-white shadow-lg transition-transform transform hover:-translate-y-2 hover:shadow-xl cursor-pointer ${
                  activeIndex === index ? "border-blue-400" : "border-transparent"
                }`}
              >
                <div className="text-4xl mb-3">{feature.icon}</div>
                <h5 className="font-semibold text-lg mb-2">{feature.title}</h5>
                <p className="text-gray-300 text-sm">{feature.desc}</p>
              </div>

              {/* Expanded Content */}
              {activeIndex === index && (
                <div className="w-full mt-3 bg-blue-950/60 border border-blue-600 rounded-xl text-left text-gray-200 p-4 shadow-md transition-all duration-300">
                  <ul className="list-disc list-inside space-y-1">
                    {feature.more.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Section;
